import React from 'react';

function Footer(props) {
    return (
        <>
            <div className="sys-footer">
                <div className="container-fluid">
                    <div className="footer-content">
                        <div className="footer-copyright">
                            © 2025 Sort Tournament Maker. All rights reserved.
                        </div>
                        <div className="footer-version">
                            Version 1.0.0
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Footer;